import type { Subscription } from '@brighterly/lib-core-types/subscription/interfaces'

import { usePaymentsStore } from '@stores/payments'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

interface SubscriptionsApiOptions {
  onStart?: () => void
  onSuccess?: () => void
  onError?: (err: any) => void
  onFinish?: () => void
}
export const useSubscriptionsApi = async (options?: SubscriptionsApiOptions): Promise<Subscription[]> => {

  const { $axios } = useNuxtApp()

  const paymentsStore = usePaymentsStore()

  const url = useCsRoutes('subscription.list.all')

  if (!url) {
    console.error('Subscriptions route not found')
    options?.onFinish?.()
    return []
  }

  paymentsStore.setSubscriptionsLoading(true)
  paymentsStore.setSubscriptionsClear()

  options?.onStart?.()

  try {
    const { data } = await $axios.get(url)
    const subscriptions = data?.data || []

    paymentsStore.setSubscriptions(subscriptions)

    options?.onSuccess?.()

    return subscriptions
  } catch (err: any) {
    console.error(err)

    options?.onError?.(err)

    return []
  } finally {
    paymentsStore.setSubscriptionsLoading(false)
    options?.onFinish?.()
  }
}
